import { gql } from '@apollo/client'

export const MESSAGE_FRAGMENT = gql`
  fragment MessageResponse on MessageResponse {
    messageId
    senderId
    content
    timestamp
    status
    username
    imageUrl
  }
`

export const PARTICIPANT_FRAGMENT = gql`
  fragment ParticipantResponse on ParticipantResponse {
    userId
    username
    imageUrl
    merchant {
      id
      name
      code
    }
  }
`

export const CONVERSATION_FRAGMENT = gql`
  fragment ConversationResponse on ConversationResponse {
    conversationId
    participants {
      ...ParticipantResponse
    }
    messages {
      ...MessageResponse
    }
  }
  ${MESSAGE_FRAGMENT}
  ${PARTICIPANT_FRAGMENT}
`

export const GET_CHATS = gql`
  query Chats($options: ConversationListOptions, $type: RoleTypeSysterm) {
    adminConversations(options: $options, type: $type) {
      items {
        ...ConversationResponse
      }
      totalItems
      totalUnreadMessages
    }
  }
  ${CONVERSATION_FRAGMENT}
`

export const GET_CHAT = gql`
  query Chat($id: ID!, $type: RoleTypeSysterm) {
    adminConversation(id: $id, type: $type) {
      ...ConversationResponse
    }
  }
  ${CONVERSATION_FRAGMENT}
`

export const SEND_MESSAGE = gql`
  mutation SendMessage($input: AddMessageInput!) {
    adminAddMessage(input: $input) {
      ...ConversationResponse
    }
  }
  ${CONVERSATION_FRAGMENT}
`

export const CREATE_CHAT = gql`
  mutation CreateChat($input: CreateConversationInput!) {
    adminCreateConversation(input: $input) {
      ...ConversationResponse
    }
  }
  ${CONVERSATION_FRAGMENT}
`
